import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = ({ theme, toggleTheme }) => {
  return (
    <header className="App-header">
      <nav>
        <Link to="/">Wellness Lab: 마음 건강 연구소</Link>
        <Link to="/blog">블로그</Link>
        <Link to="/about">소개</Link>
        <Link to="/contact">문의</Link>
        <Link to="/privacy">개인정보처리방침</Link>
        <button onClick={toggleTheme} className="theme-toggle">
          {theme === 'light' ? '다크 모드' : '라이트 모드'}
        </button>
      </nav>
    </header>
  );
};

export default Header;
